export default __webpack_public_path__ + "static/media/awaiting0.3587cc8a.svg";